import { LineItem } from 'components/bookings'
import {
  ArenaBookingInfo,
  BookingDateInput,
  Period,
} from 'lib/graphql/storeadmin'

export interface SelectedVariant {
  variantId: string
  title: string
  productName: string
  price: number
  specialPrice: number
  inventory?: number
  baseTimeUnit?: number
  arenaBookingInfo?: ArenaBookingInfo[]
}

export interface SelectedVariantListCardProps {
  selectedVariants?: SelectedVariant[]
  period?: Period
  bookingDates?: BookingDateInput
  isSagaArena: boolean
  isBookingDetail?: boolean
}

export const SelectedVariantListCard = ({
  selectedVariants,
  period,
  bookingDates,
  isSagaArena,
  isBookingDetail,
}: SelectedVariantListCardProps) => (
  <div className="space-y-8">
    {selectedVariants?.map((variant) => (
      <LineItem
        key={variant.variantId}
        title={variant.productName}
        variantTitle={variant.title}
        price={variant.price}
        specialPrice={variant.specialPrice}
        period={period}
        baseTimeUnit={variant.baseTimeUnit}
        bookingDates={bookingDates}
        isSagaArena={isSagaArena}
        isBookingDetails={isBookingDetail}
      />
    ))}
  </div>
)
